import SimpleFileFolder from 'components/SimpleFileFolder'
import styles from './styles.css'
import SectionHeader from '../../Header/SectionHeader'

export default function RequestDocument(props) {
  const { onUploadClick, files, onDeleteClick } = props

  const hasNoFiles = !files || files.length === 0

  return (
    <div className={styles.cardMarginBot}>
      <SectionHeader title={'Request Documents'} className={styles.invoiceReviewHeader} />
      <section className={styles.requestDocumentSection}>
        <section className={styles.subSection}>
          <div className={styles.fileUpload}>
            <div className={styles.fileUploadComponent}>
              <SimpleFileFolder onUploadClick={onUploadClick} files={files} onDeleteClick={onDeleteClick} layout="horizontal" />
            </div>
            {hasNoFiles && (
              <div className={styles.rowError}>
                <span className={styles.error}>Document upload is required</span>
              </div>
            )}
          </div>
        </section>
      </section>
    </div>
  )
}
